
















































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getUnitVideos, getUnitList
} from '@/api/videoDevice/play'
import { DDLItem, DefDDLItem } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import { dateFormat, newGuid } from '@/configs/functions'
import cbHikVideo from '@/components/hikVideo/index.vue'

import { ElCol } from 'element-ui/types/col'
const AppModule = namespace('app')

import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
import { enUserType } from '@/configs/enums'
const UserModule = namespace('user')
@Component({
  components: {
    cbHikVideo
  }
})
/** 视频回放 */
export default class VideoPlayBack extends Vue {
  @UserModule.Getter('userInfo')
  public curUser!: UserData
  public get isUserCity(): boolean {
    var userType = this.curUser.UserType
    return userType == enUserType.CityHeritage || userType == enUserType.CityFinance
  }
  public get isUserProvince(): boolean {
    var userType = this.curUser.UserType
    return userType == enUserType.ProvinceHeritage || userType == enUserType.ProvinceFinance
  }

  @AppModule.Getter
  public sidebar!: { opened: boolean, withoutAnimation: boolean }
  public $refs!: {
    refHikVideo: any
    refCol: ElCol
  }
  public targetId: string = newGuid()
  public layout: string = '1x1'
  public wndNum: number = 1
  public vWidth: number = 1000
  public vHeight: number = 600

  public listLoading: boolean = false
  public onlyOnline: boolean = false
  public list: any[] = []
  public queryTerm = {
    Page: 0,
    PageSize: 999,
    SortBy: 'UnitName',
    IsAsc: false,

    /**0全部 1离线 2在线 3未知 */
    OnlineStatus: 0,
    Keyword: ''
  }

  public form: any = {
    VideoId: 0,
    UnitCode: '',
    UnitName: '',
    DeviceName: '',
    DeviceNumber: ''
  }
  public firstType: number = enFirstType.All
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public levelList: DDLItem[] = []
  public classifyList: DDLItem[] = []
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]

  public expandKey: number[] = []
  public fetchVideo(row: any, expandedRows: any) {
    if (!row.childs || row.childs.length == 0) {
      row.childs = []
      row.loading = true
      var onlineStatus = this.onlyOnline ? 2 : 0
      getUnitVideos(row.UnitId, onlineStatus).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          row.childs = data
          row.loading = false
          var index = this.list.findIndex((v: any) => v.UnitId == row.UnitId)
          this.$set(this.list, index, row)
        }
      })
    }
  }

  public unitClick(e: any) {
    var index = this.expandKey.findIndex((v: number) => v == e.UnitId)
    if (index == -1) {
      this.expandKey = [e.UnitId]
      this.fetchVideo(e, null)
    }
    else {
      this.expandKey.splice(index, 1)
    }
  }

  //#region 视频控件 相关代码
  public getWidth(): number {
    var dom = document.getElementById("videoContainer")
    var w = dom ? dom.offsetWidth : 860
    return w
  }
  public getHeight(): number {
    var h = document.documentElement.clientHeight - 200
    //屏幕高度
    // var eh = document.documentElement.clientHeight
    // if (h > eh) {
    //   h = eh
    // }
    return h
  }
  public playList: { code: string, wndId: number }[] = []
  public playingMsg: string = ''
  public curVideoCode: string = ''
  public curStreamMode: number = 0
  public playVideo(row: any, unitName: string) {
    var msg: string = ''
    // if (row.IsSourceDelete) {
    //   msg = '设备已停止'
    // }
    // else 
    if (row.Online != 1) {
      msg = '设备不在线'
    }
    if (msg != '') {
      this.$message.warning(msg)
      return false
    }
    this.curVideoCode = row.PointNumber
    this.curStreamMode = row.StreamMode
    this.playingMsg = ' - ' + unitName + '/' + row.PointName

    //默认播放1个小时
    var startTimeStamp = new Date(new Date().setHours(new Date().getHours() - 12)) // new Date().getTime() - 60 * 60 * 1000 //回放开始时间戳，必填 
    var endTimeStamp = new Date(new Date().setHours(new Date().getHours() - 2))
    this.startTime = dateFormat(startTimeStamp, 'yyyy-MM-ddThh:mm')
    this.endTime = dateFormat(endTimeStamp, 'yyyy-MM-ddThh:mm')
    this.startPlayBack()
  }
  public pointRowClass(data: { row: any, rowIndex: number }) {
    const row = data.row
    let name = ''
    if (this.curVideoCode == row.PointNumber) {
      name = 'row-checked'
    }
    return name
  }
  public startTime: any = ''
  public endTime: any = ''
  public startPlayBack() {
    var opt = {
      videoCode: this.curVideoCode,
      streamMode: this.curStreamMode,
      startDate: this.startTime,
      endDate: this.endTime
    }
    this.$refs.refHikVideo.startPlayBack(opt)
  }
  public loadCtrls() {
    this.$nextTick(() => {
      this.vWidth = this.getWidth()
      this.vHeight = this.getHeight()
      if (this.$refs.refHikVideo) {
        this.$refs.refHikVideo.initPlugin()
        //注销掉，重新调用
        window.onresize = null
        //页面大小变动时，重新加载控件
        window.onresize = () => {
          this.videoResize()
        }
        window.onscroll = null
        //页面大小变动时，重新加载控件
        window.onscroll = () => {
          this.videoResize()
        }
      }
    })
  }
  public videoResize() {
    if (this.$refs.refHikVideo) {
      let w = this.getWidth()
      let h = this.getHeight()
      this.$refs.refHikVideo.setResize(w, h)
    }
  }
  /** 监听数据变化 */
  @Watch('sidebar', { deep: true })
  SidebarWatch(data: any) {
    this.videoResize()
  }
  public beforeDestroy() {
    window.eventBus.$off('cbHik_refreshPlayList')
    window.onresize = null
    window.onscroll = null
  }
  //#endregion

  public created() {
    if (this.targetId = '') {
      this.targetId = newGuid()
    }
  }
  public showVideoCtrl: boolean = true
  public mounted() {
    window.eventBus.$on('cbHik_refreshPlayList', (info: any) => {
      if (info.targetId == this.targetId) {
        this.playList = info.playList
      }
    })
    this.loadCtrls()
    this.fetchData()
  }

  public fetchData() {
    this.listLoading = true
    this.expandKey = []
    getUnitList(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        var items = data.Results
        this.list = items
        /*
        //页面首次加载时，默认打开第一个节点
        if (this.expandKey.length == 0 && items.length > 0) {
          var row = items.find((v: any) => v.OnlineCount > 0)// units[0]
          if (row && row.UnitId > 0) {
            this.expandKey = [row.UnitId]
            this.fetchVideo(row, null)
          }
        }
        */
      }
      this.listLoading = false
    })
  }
  public doSearch() {
    this.fetchData()
  }
  public onlineChange() {
    this.queryTerm.OnlineStatus = this.onlyOnline ? 2 : 0
    this.doSearch()
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.showVideoCtrl = false
    setTimeout(() => {
      this.showVideoCtrl = true
      this.loadCtrls()
      this.doSearch()
    }, 500)
    //重置数据
    Object.assign(this.$data, this.$options.data)
  }
}
